import React from 'react';

import { toGenericInputCreateRequest } from './common/formDataAdapter';
import { SidebarProvider } from './context/Sidebar';
import { FormDataProvider } from './context/FormData';
import { StepsProvider } from './context/Steps';
import { AdvancedOptionsProvider } from './context/AdvancedOptions';
import Salesforce from './Salesforce';
import INITIAL_FORMDATA from './_initialFormData';

type Props = {
  onSubmit?: (InputCreateRequest) => void;
};

const EmbeddedSalesforceApp = ({ onSubmit = undefined }: Props) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }

    onSubmit(toGenericInputCreateRequest(formData));
  };

  return (
    <StepsProvider>
      <FormDataProvider initialFormData={INITIAL_FORMDATA}>
        <SidebarProvider>
          <AdvancedOptionsProvider>
            <Salesforce onSubmit={handleSubmit} externalInputSubmit={typeof onSubmit === 'function'} />
          </AdvancedOptionsProvider>
        </SidebarProvider>
      </FormDataProvider>
    </StepsProvider>
  );
};

export default EmbeddedSalesforceApp;
